import { call, put } from 'redux-saga/effects';
import { get, isNil, omitBy } from 'lodash/fp';
import { toastr } from 'react-redux-toastr';
import * as Api from '../../../services/fbm-api';
import { sagaRoutineRequest } from '../../../helpers/saga';
import {
  fetchDownloadRequests as fetchDownloadRequestsRoutine,
  fetchDownloadRequest as fetchDownloadRequestRoutine,
  fetchDownloadRequestResult as fetchDownloadRequestResultRoutine,
  fetchDownloadRequestsSearchOptions as fetchDownloadRequestsSearchOptionsRoutine,
  createDownloadRequest as createDownloadRequestRoutine,
  deleteDownloadRequest as deleteDownloadRequestRoutine
} from './routines';
import {
  clearDownloadRequests,
  clearDownloadRequestsSearchOptions
} from '../../actions/download-request';
import history from '../../../routes/history';
import { formatDateRange } from '../../../helpers/dates';
import viewPathByContenxt from '../../../helpers/downloadRequestViewPathByContenxt';

export const fetchDownloadRequests = ({ payload = {} }) => {
  const qs = omitBy(each => !each && isNil(each), payload);
  const createdAt = get('createdAt', qs);
  const completedAt = get('completedAt', qs);
  const options = {
    qs: {
      ...qs,
      ...(createdAt ? { createdAt: formatDateRange(createdAt) } : {}),
      ...(completedAt ? { completedAt: formatDateRange(completedAt) } : {})
    }
  };

  return sagaRoutineRequest(fetchDownloadRequestsRoutine, {
    request: () => call(Api.fetchDownloadRequests, options)
  });
};

export const fetchDownloadRequest = ({ payload: id }) =>
  sagaRoutineRequest(fetchDownloadRequestRoutine, {
    request: () => call(Api.fetchDownloadRequest, id)
  });

export const createDownloadRequest = ({ payload: body }) =>
  sagaRoutineRequest(createDownloadRequestRoutine, {
    request: () => call(Api.createDownloadRequest, { body }),
    *success({ id, context }) {
      yield put(clearDownloadRequests());
      yield put(clearDownloadRequestsSearchOptions());
      const viewPath = get(context, viewPathByContenxt);
      history.push(viewPath.replace(':id', id));
    }
  });

export const fetchDownloadRequestResult = ({ payload: id }) =>
  sagaRoutineRequest(fetchDownloadRequestResultRoutine, {
    request: () => call(Api.fetchDownloadRequestResult, id),
    successPayload: { id }
  });

export const fetchDownloadRequestsSearchOptions = ({ payload: qs }) =>
  sagaRoutineRequest(fetchDownloadRequestsSearchOptionsRoutine, {
    request: () => call(Api.fetchDownloadRequestsSearchOptions, { qs })
  });

export const deleteDownloadRequest = ({ payload: { name, id, context } }) =>
  sagaRoutineRequest(deleteDownloadRequestRoutine, {
    request: () => call(Api.deleteDownloadRequest, { id, context }),
    successPayload: { id },
    *success() {
      yield toastr.success('Success', `Deleted "${name}" Report.`);
    }
  });
